import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, debounce, Options} from "../utils/decorators";


@Options({
    template: false,
    ui: {
        tooltipTrigger:     '[data-js-ui=tooltip-trigger]',
    }
})
export default class TooltipView extends Marionette.View<Backbone.Model>{

    _$body = $('body');
    _tooltipSelector = '[data-js-ui="tooltip"]';
    _$tooltips = $('[data-js-ui="tooltip"]');
    _showTooltipClass = "is-showing-tooltip";

    @on("click @ui.tooltipTrigger")
    onTooltipTriggerClick(e: JQueryEventObject) {
        const $target = $(e.currentTarget);
        const $tooltip = $target.find(this._tooltipSelector);
        const isOpen = $tooltip.hasClass(this._showTooltipClass);

        if (isOpen) {
            this.closeTooltips();
        } else {
            this.closeTooltips();
            $tooltip.addClass(this._showTooltipClass);
            _.delay(_.bind(this.listenForBodyClick, this), 500);
        }
    }

    closeTooltips() {
        this._$tooltips.removeClass(this._showTooltipClass);
        this._$body.off("click.outsideTooltips");
    }

    listenForBodyClick() {
        this._$body.on("click.outsideTooltips", this.closeTooltips.bind(this));
    }
}



// WEBPACK FOOTER //
// ./@modules/views/tooltip-view.ts